import { Errors } from 'shared/errors';

export type ProgressCallback = (url: string, progress: number) => void;

export async function downloadWithProgress(url: string, progressCallback: ProgressCallback, signal?: AbortSignal): Promise<Blob> {
    progressCallback(url, 0);

    const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'same-origin',
        keepalive: false,
        signal,
    });

    const { body, headers } = response;
    const contentLength = +headers.get('Content-Length')!; // Coerced to a number

    const reader = body?.getReader();
    if (!reader) {
        console.debug(`Download of ${url} had no body:`, JSON.stringify(response));
        throw new Error(Errors.SERVER_ERROR);
    }

    let receivedLength = 0;
    const chunks = [];
    while (!signal?.aborted) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        receivedLength += value.length;

        if (contentLength) {
            const progress = receivedLength / contentLength;
            progressCallback(url, progress);
        }
    }

    return new Blob(chunks);
}
